import React from 'react';
import CONSTANTS from 'chat-constants';

const ChannelSelectorChannel = (props) => {
  const { channel } = props;
  const styles = CONSTANTS.CHANNEL.DETAILS[channel.type];
  return (
    <div className={`ChannelSelector__channel`}>
      <i title={styles.NAME} className={styles.ICON}></i>
      <span>{channel.name}</span>
    </div>
  );
};

export default ChannelSelectorChannel;
